// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const venonat: PokeData = {
  "id": 48,
  "name": "venonat",
  "height": 10,
  "weight": 300,
  "base_experience": 61,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "tackle",
    "supersonic",
    "disable",
    "psybeam",
    "mega-drain",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "confusion",
    "psychic",
    "leech-life",
    "foresight",
    "poison-fang",
    "signal-beam",
    "bug-buzz",
    "zen-headbutt",
    "struggle-bug"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "poison-powder",
    "stun-spore",
    "psychic",
    "poison-fang",
    "bug-buzz",
    "zen-headbutt",
    "purify",
    "poison-gas",
    "venom-drench",
    "sticky-web",
    "infest"
  ],
  "evolution_chain": {
    "id": 20,
    "item": null,
    "species": [
      {
        "name": "venonat",
        "order": 53,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "venomoth",
        "order": 54,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 48,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 45,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
